import moment from 'moment';
import { useContext } from 'react';
import { PostContext } from '../../../../../context/PostContext';

const ExpiredRecruitDate = () => {
  const { allowUploadedFile, endDate } = useContext(PostContext);

  return (
    <>
      {allowUploadedFile && (
        <div className="bg-Other/Rating text-Text/Lightbackground/Primary rounded-lg font-medium py-[5px] px-4 my-2 flex items-center">
          <span className="text-sm leading-[120%] mr-1">Hạn nộp:</span>
          <span className="text-base leading-[140%] tracking-[-0.2px]">
            {moment(endDate).format('HH:mm - DD/MM/YYYY')}
          </span>
        </div>
      )}
    </>
  );
};

export default ExpiredRecruitDate;
